import script from "./FranchiseRequestSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseRequestSheet.vue?vue&type=script&setup=true&lang=js"

import "./FranchiseRequestSheet.vue?vue&type=style&index=0&id=d7f22984&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7f22984"]])

export default __exports__